"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEPhoneInput = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _react = _interopRequireWildcard(require("react"));

var _materialUiPhoneNumber = _interopRequireDefault(require("material-ui-phone-number"));

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAEText = require("../FAEText/FAEText");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

require("./FAEPhoneInput.scss");

const _excluded = ["justify", "align", "className", "primary", "shadowBoxProps", "isRequired", "label", "getValue", "value", "disabled"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEPhoneInput = _ref => {
  let {
    justify,
    align,
    className = "",
    primary,
    shadowBoxProps,
    isRequired,
    label,
    getValue = () => {},
    value = "",
    disabled
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [initialValue, setInitialValue] = (0, _react.useState)("");

  const handleChangeValue = _ref2 => {
    let {
      code,
      number
    } = _ref2;
    setInitialValue(value);
    number.length > 3 ? getValue("+".concat(code, "-").concat(number.replace("+", "").replace(code, "").replaceAll(" ", "").replace(/[^\w\s]/gi, ""))) : getValue(number);
  };

  (0, _react.useEffect)(() => {
    setInitialValue(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, primary ? /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({}, shadowBoxProps, {
    padding: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--phone-input-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_materialUiPhoneNumber.default, _extends({
    name: "phone",
    "data-cy": "user-phone",
    defaultCountry: "gb",
    className: className,
    value: initialValue,
    disabled: disabled,
    disableDropdown: disabled,
    onChange: (number, countrydata) => handleChangeValue({
      code: countrydata.dialCode,
      number
    })
  }, rest)))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--select-container ".concat(className)
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    important: isRequired && true,
    tertiary: true
  }, label), /*#__PURE__*/_react.default.createElement(_materialUiPhoneNumber.default, _extends({
    name: "phone",
    "data-cy": "user-phone",
    defaultCountry: "gb",
    className: className,
    variant: "outlined",
    value: initialValue,
    disabled: disabled,
    disableDropdown: disabled,
    onChange: (number, countrydata) => handleChangeValue({
      code: countrydata.dialCode,
      number
    })
  }, rest)))));
};

exports.FAEPhoneInput = FAEPhoneInput;